import { $authHost } from ".";

export async function getDeposits() {
  const response = await $authHost.request({
    url: "/deposits",
  });
  return response;
}
